import ImageWithFallback from 'components/ImageWithFallback';
import DrawCountdownString from 'components/token-town/draws/draw-countdown/DrawCountdown';
import { CONFIRMATION_ASSET_FOLDER } from 'constants/Confirmation';
import { useMemo } from 'react';
import styles from './ConfirmationDrawCountdown.module.css';

interface ConfirmationDrawCountdownProps {
  date: Date | null;
}

const ConfirmationDrawCountdown = (props: ConfirmationDrawCountdownProps) => {
  const date = useMemo(
    () => (props.date ? new Date(props.date) : undefined),
    [props.date],
  );

  return (
    <div className={styles.confirmationDrawCountdown}>
      <div className={styles.countdownImageContainer}>
        <div className={styles.countdownImageWrapper}>
          <ImageWithFallback
            src={`${CONFIRMATION_ASSET_FOLDER}/clock.svg`}
            layout="fill"
          />
        </div>
      </div>

      <div className={styles.content}>
        <p>
          <strong> Your first draw is in:</strong>
        </p>
        <span className={`aboutUsTypographyHeaderMedium ${styles.countdown}`}>
          {date ? (
            <DrawCountdownString
              date={date}
              initialValue="--- : --- : --- : ---"
            />
          ) : (
            '--- : --- : --- : ---'
          )}
        </span>
      </div>
    </div>
  );
};

export default ConfirmationDrawCountdown;
